// icons
import {
  MdFolderOpen,
  MdDashboard,
  MdFlag,
  MdLightbulb,
  MdTrackChanges,
  MdCalendarMonth,
  MdViewWeek,
  MdViewDay,
  MdTask,
  MdAccountBalance,
  MdArticle,
  MdHistory,
  MdEditNote,
  MdSearch,
  MdAutoAwesome,
  MdAccountTree,
  MdBook,
  MdFolder,
  MdTimeline,
  MdPeople
} from "react-icons/md";

const proyectos = {
  id: 'proyectos-group',
  type: 'group',
  roles: [1, 100, 110],
  breadcrumbs: false,
  children: [
    {
      id: 'selector-proyectos',
      title: 'Proyectos',
      type: 'item',
      breadcrumbs: false,
      icon: MdFolderOpen,
      url: '/selector-proyectos'
    },
    {
      id: 'dashboard-proyecto',
      title: 'Dashboard Proyecto',
      type: 'item',
      breadcrumbs: false,
      icon: MdDashboard,
      url: '/dashboard-proyecto'
    },
    {
      id: 'inteligencia-diagnostico',
      title: 'Inteligencia de diagnóstico',
      type: 'collapse',
      icon: MdSearch,
      children: [
        {
          id: 'diagnostico-360-digital',
          title: 'Diagnóstico 360 digital',
          type: 'item',
          breadcrumbs: false,
          icon: MdSearch,
          url: '/inteligencia-diagnostico/diagnostico-360-digital'
        },
        {
          id: 'checklist-arranque',
          title: 'Checklist de arranque',
          type: 'item',
          breadcrumbs: false,
          icon: MdTask,
          url: '/inteligencia-diagnostico/checklist-arranque'
        },
      ]
    },
    {
      id: 'motor-estrategico-adaptativo',
      title: 'Motor estratégico adaptativo',
      type: 'item',
      breadcrumbs: false,
      icon: MdAutoAwesome,
      url: '/motor-estrategico-adaptativo'
    },
    {
      id: 'plan-estrategico',
      title: 'Plan estratégico',
      type: 'collapse',
      icon: MdFlag,
      children: [
        {
          id: 'vision-estrategica',
          title: 'Visión estratégica',
          type: 'item',
          breadcrumbs: false,
          icon: MdLightbulb,
          url: '/plan-estrategico/vision-estrategica'
        },
        // {
        //   id: 'objetivo-smart',
        //   title: 'Objetivo SMART',
        //   type: 'item',
        //   breadcrumbs: false,
        //   icon: MdTrackChanges,
        //   url: '/plan-estrategico/objetivo-smart'
        // },
        {
          id: 'cronograma',
          title: 'Cronograma',
          type: 'item',
          breadcrumbs: false,
          icon: MdCalendarMonth,
          url: '/plan-estrategico/cronograma'
        },
        {
          id: 'planificador-semanal',
          title: 'Planificador semanal',
          type: 'item',
          breadcrumbs: false,
          icon: MdViewDay,
          url: '/plan-estrategico/planificador-semanal'
        },
        {
          id: 'administrador-tareas',
          title: 'Administrador de tareas',
          type: 'item',
          breadcrumbs: false,
          icon: MdTask,
          url: '/plan-estrategico/administrador-tareas'
        }
      ]
    },
    {
      id: 'sistematizacion-estructura-organizacional',
      title: 'Sistematización y Estructura Organizacional',
      type: 'collapse',
      icon: MdAccountTree,
      children: [
        {
          id: 'organigrama-y-perfiles-de-puestos',
          title: 'Organigrama y perfiles de puestos',
          type: 'collapse',
          icon: MdPeople,
          children: [
            {
              id: 'estructura-actual',
              title: 'Estructura actual',
              type: 'item',
              breadcrumbs: false,
              icon: MdPeople,
              url: '/sistematizacion-estructura-organizacional/organigrama-y-perfiles-de-puestos'
            },
            {
              id: 'analisis-de-organigrama',
              title: 'Análisis de organigrama',
              type: 'item',
              breadcrumbs: false,
              icon: MdAccountTree,
              url: '/sistematizacion-estructura-organizacional/analisis-de-estructura-organizacional'
            }
          ]
        },
        {
          id: 'procesos',
          title: 'Procesos',
          type: 'item',
          breadcrumbs: false,
          icon: MdTimeline,
          url: '/sistematizacion-estructura-organizacional/procesos-de-la-empresa'
        }
      ]
    },
    {
      id: 'monitor-financiero',
      title: 'Monitor financiero',
      type: 'item',
      breadcrumbs: false,
      icon: MdAccountBalance,
      url: '/monitor-financiero'
    },
    // {
    //   id: 'reporte-mensual',
    //   title: 'Reporte mensual',
    //   type: 'collapse',
    //   icon: MdArticle,
    //   children: [
    //     {
    //       id: 'historial-reportes',
    //       title: 'Historial de reportes',
    //       type: 'item',
    //       breadcrumbs: false,
    //       icon: MdHistory,
    //       url: '/reporte-mensual/historial-reportes'
    //     },
    //     {
    //       id: 'generador-borrador',
    //       title: 'Generador de borrador',
    //       type: 'item',
    //       breadcrumbs: false,
    //       icon: MdEditNote,
    //       url: '/reporte-mensual/generador-borrador'
    //     }
    //   ]
    // },
    
    {
      id: 'administrador-archivos',
      title: 'Administrador de archivos',
      type: 'item',
      breadcrumbs: false,
      icon: MdFolder,
      url: '/administrador-archivos',
      roles: [1]
    },
    {
      id: 'modulo-minutas',
      title: 'Módulo de minutas',
      type: 'item',
      breadcrumbs: false,
      icon: MdBook,
      url: '/modulo-minutas'
    },
    {
      id: 'clientes-repositorio-de-archivos',
      title: 'Repositorio de archivos',
      type: 'item',
      breadcrumbs: false,
      icon: MdFolder,
      url: '/clientes/repositorio-de-archivos'
    },
  ]
};

export default proyectos;
